import axios from 'axios';


import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Panel } from 'primereact/panel';
import { Rating } from 'primereact/rating';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { getUrl } from '../../../../../ApiCall/GetUrl';
import ConfirmaCita from './ConfirmaCita';

export default function Info() {

  let fecha = new Date();
/*
  function confirmCalendar( comment  )
  {
    console.log( "Confirm = " , theClient )
    console.log( "Comment = " + comment ) ;

    var myClient = theClient ;
    myClient.comment = comment ;

    //return ;

    axios.post( getUrl() + "/confirmacita" , myClient )
    .then((response) => {

      console.log( response )

      setHorarios( [])

      getHorarios() ; // Recargamos los horarios

    })
    .catch((err)=>{
      console.log( err) ;
    })



  }

*/

  function dateDiffInDays(d1, d2) {
    d2.setHours(0, 0, 0, 0) // date.setHours(0, 0, 0, 0)
    d1.setHours( 0 , 0 , 0 , 0 )

    var t2 = d2.getTime();
    var t1 = d1.getTime();



    return Math.floor((t2 - t1) / (24 * 3600 * 1000));
  }


  const location = useLocation();


  const months = {
    1: "Enero",
    2: "Febrero",
    3: "Marzo",
    4: "Abril",
    5: "Mayo",
    6: "Junio",
    7: "Julio",
    8: "Agosto",
    9: "Septiembre",
    10: "Octubre",
    11: "Noviembre",
    12: "Diciembre"
  };
  var columns = [];

  var id = location.state.id

  // Peticiones a la base de datos

  console.log( "En modedal id = " + id )

  var [lawyers, setLawyers] = useState([]);
  var [horarios, setHorarios] = useState([]);
  var [horariosFull, setHorariosFull] = useState([1])
  var [value, setValue] = useState(null);
  const [theState, setTheState] = useState(false)
  const [theClient, setTheClient] = useState(null)
  const [especialidades, setEspecialidades] = useState([]);

  useEffect(() => {

    //axios.get(getUrl() + `/getModalLawyer?id=${id}`).then((response) => {
    axios.get('https://boxy.currenmexico.com/legalup/getModalLawyer?id=' + id).then((response) => {

      // https://boxy.currenmexico.com/legalup
      console.log("Response para el getLawyer: ", response.data[0])
      setLawyers(response.data[0]);
    }).catch((e) => {
      console.log("Hubo un error en getLawyer: ", e)
    })
    // axios.get(`http://localhost:3005/getInfoEspecialidades?id=${id}`).then((response) => {
    // axios.get(`http://localhost:3005/getInfoEspecialidades?id=${id}`).then((response) => {
    //   console.log("Response Especialidades: ", response.data)
    //   setEspecialidades(response.data[0]);
    //   console.log("Especialidades Arr: ", especialidades)
    //   console.log("Estas son las especialidades", response.data)
    // }).catch((e) => {
    //   console.log("There was an error en especialidades: ", e)
    // })

  }, [])

  useEffect(() => {
    setEspecialidades([{ name: "Civil", description: "Prueba de descripción", id: 1 }])
  }, [])



  const ind = 1;



  function confirmCalendar(comment) {
    console.log("Confirm = ", theClient)
    console.log("Comment = " + comment);

    var myClient = theClient;
    myClient.comment = comment;

    //return;

    axios.post(getUrl() + "/confirmacita", myClient)
      .then((response) => {

        console.log(response)

        setHorarios( [])

        getHorarios() ; // Recargamos los horarios
  

      })
      .catch((err) => {
        console.log(err);
      })



  }

  useEffect(() => {

    console.log("Tarjeta *** theState = ", theState);

  }, [theState])

  function onOver(event) {
    event.target.style.borderColor = 'black';
  }

  function onOut(event) {
    event.target.style.borderColor = 'transparent';
  }

  // [ { id :1 , horarios : [ ] } , { id :2 , horarios : [ ] }  ]



  function onClick(val) {
    //console.log( "client = " , event.target.current.client ) ;
    console.log("client = ", val.target.attributes["client"].value) // day={0} hour={'08:00'}
    console.log("day = ", val.target.attributes["day"].value)
    console.log("hour = ", val.target.attributes["hour"].value)

    var status = val.target.attributes["status"].value
    console.log("status = ", status)


    if (status === "2") {
      return;
    }

    var result = new Date();
    result.setDate(result.getDate() + parseInt(val.target.attributes["day"].value));

    var obj = {

      idcalendar : val.target.attributes["idcalendar"].value ,
      idlawyer: val.target.attributes["lawyer"].value, // Hay que traerlo
      idclient: val.target.attributes["client"].value,
      //day : val.target.attributes["day"].value ,

      //hour : val.target.attributes["hour"].value ,

      datetime: getFormatDateShort(result) + " " + val.target.attributes["hour"].value,
      status: 2 // Cita confirmada


    }
    setTheClient(obj);
    setTheState(theState => !theState);
    console.log("onClick = ", theState)
    // val.target.attributes["row"]
  }

  var columns = [];


  for (let i = 0; i < 14; i++) {
    var obj = { field: i.toString() /*fecha.getDate()*/, header: `${fecha.getDate()} ${months[(fecha.getMonth() % 12) + 1]}` };
    columns.push(obj);

    fecha.setDate(fecha.getDate() + 1);
  }
  var navigate = useNavigate();
  //const location = useLocation();
/*
  const navigateAux = (id) => {
    if (id === null) {
      return;
    }
    navigate("/info", { state: { id: id } })


  }
*/
  useEffect(() => {
    getHorarios();
  }, [lawyers])


  function getHorarios() {
    axios.get(getUrl() +  `/horarioslawyerid?id=${id}`).then(response => {

      console.log("horarioslawyer = ", response.data);
      let arr = [];
      for (let i = 0; i < response.data.length; i++) {
        console.log("i: ", i)
        console.log("response.data[i]: ", response.data[i])
        arr.push(response.data[i])
      }
      console.log("Arr: ", arr)
      //setHorarios([]);
      setHorarios(arr)
      console.log("Este es el response data de horarios: ", response.data);

      //buildHorarios() ;

    }).catch(error => {
      console.log("Error fetching data de horarios: ", error);
      setHorarios(["Hubo un error al obtener la información"]);
    })
  }


  useEffect(() => {

    console.log( "Antes de llamar a buildHorartios")

    if (horarios.length > 0) {
      var theHorarios = buildHorarios()

      setHorariosFull(theHorarios);
    }

  }, [horarios])


  function buildHorarios() {
    var arr = [];


    console.log( "Dentro de buildhorarios")

    console.log("lawyers.length = " + lawyers.length)

    for (var i = 0; i < 2; i++) // Recorremos cada uno de los horarios
    {
      var obj = {

        id: id,
        horarios: fillEmpty(id)

      }

      arr.push(obj);

    }

    //console.log( "Aqui va el primer cliente ---")
    //console.log( arr )

    return arr;
  }

  function fillEmpty(id) // dd del cliente
  {

    //console.log( "A procesar " + id )

    var arr = []

    var hrs = [

      "08:00",
      "08:30",
      "09:00",
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "13:30",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "16:30",
      "17:00",
      "17:30",
      "18:00",
      "18:30",
      "19:00",
      "19:30",
      "20:00",
      "20:30",

    ]

    for (var i = 0; i < 26; i++) // Todos los horarios
    {

      var row = [] // Este es un renglon con horarios

      for (var j = 0; j < 14; j++) // todos los dias
      {

        //console.log( "horarios.length = " + horarios.length + " id = " + id )

        var horariofound = "----"

        var isFound = false;

        for (var k = 0; k < horarios.length; k++) {
          //console.log( "horarios.datetime = " + horarios[k].datetime + " cliente = " + id )

          var localDate = new Date(horarios[k].datetime)

          localDate.setHours(localDate.getHours() + 2);

          var strDate = getFormatDate(localDate)

          

          //return ;

          strDate = strDate.substring(11, 16)

          //console.log( "strDate = " + strDate )

          var theDiff = dateDiffInDays(new Date(), localDate)

          console.log( "date = " + new Date() + "  localdate = " +  getFormatDate( localDate ) )
          
          console.log( "strDate = *****" + strDate + " theDiff = " + theDiff ) ; // 11 , 5

          //return ; 

          //var isFound = false ;

          if (horarios[k].idlawyer === id && theDiff === j) {
            //console.log( "k = " + k)

            if (strDate === hrs[i]) {
              console.log("strDate = " + strDate + " hrs = " + hrs[i] + " index = " + i)
              console.log("Si encontramos horario en el cliente******** " + id + " dia = " + theDiff)
              console.log("localdate = " + localDate)
              console.log("Siguiente = " + hrs[i + 1])


              horariofound = <button onMouseOver={onOver} client={id} idcalendar={horarios[k].id}
                lawyer={id} day={theDiff} hour={hrs[i]} status={horarios[k].status}
                title={horarios[k].status === 1 ? 'Disponible' : "Reservado"}
                onMouseOut={onOut} onClick={(val) => onClick( val )}
                style={{
                  borderRadius: '4px', width: '70px', textDecoration: horarios[k].status === 2 ? 'line-through' : '',
                  height: '35px', color: "black", borderColor: 'transparent', backgroundColor: "rgb(238,244,256)"
                }}>{hrs[i]}</button>

              isFound = true;

            }


          }

          if (!isFound) {
            horariofound = <p style={{ textDecoration: 'line-through' }}>{hrs[i]} </p>
          }

        }

        row.push(horariofound)
      }

      arr.push(row)

    }

    return arr;

  }

  


 /* 
  function dateDiffInDays(d1, d2) {
    d2.setHours(0, 0, 0, 0) // date.setHours(0, 0, 0, 0)

    var t2 = d2.getTime();
    var t1 = d1.getTime();



    return Math.floor((t2 - t1) / (24 * 3600 * 1000));

  }
  */


  function getFormatDate(d) {
    var date = new Date(d);
    var dateStr =
      date.getFullYear() + "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2) + " " +
      ("00" + date.getHours()).slice(-2) + ":" +
      ("00" + date.getMinutes()).slice(-2) + ":" +
      ("00" + date.getSeconds()).slice(-2);
    //console.log(dateStr);

    return dateStr;
  }

  function getFormatDateShort(d) {
    var date = new Date(d);
    var dateStr =
      date.getFullYear() + "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) + "-" +
      ("00" + date.getDate()).slice(-2)

    //console.log(dateStr);

    return dateStr;
  }


  return (<>
    <div className='container mt-5'>
      <div className='row'>
        <div className='w-50'>
          <img className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round" src={lawyers.lawyer_photograph} />
        </div>
        <div className='w-50'>
          <h1 className='name'>{lawyers.lawyer_name} {lawyers.lawyer_appaterno} {lawyers.lawyer_apmaterno === null ? "" : lawyers.lawyer_apmaterno}</h1>
          <div className='calificacion'>
            <Rating cancel={false} value={lawyers.calificación} />
          </div>
        </div>
        {/*<div className='w-50'>
          {especialidades.length > 0 ? especialidades?.map((esp) => {
            <p>{esp.name}</p>
          }) : null}
        </div>
*/}
      </div>
      <div className='mt-5'>
        <Panel header="Horarios">
          <div className='col' style={{ overflowX: 'auto', maxWidth: '100%' }}>

            <DataTable value={(ind >= 0 ? horariosFull[ind]?.horarios : [])   /*horarios[lawyer[]]*/} tableStyle={{ minWidth: '50rem', minHeight: '180px' }} scrollable scrollHeight="400px">
              {columns.map((col, index) => {
                return <Column key={index} field={index.toString()} header={col.header} style={{ height: '20px' }} />
              })}
            </DataTable>
          </div>
        </Panel>
      </div>
      <div className='mt-5'>
        <Panel header="Curriculum">
          <div className='row'>

            <div className="col">

              <p>Fecha de inicio de trabajo: {lawyers.lawyer_working_begin_date?.slice(0, 10)}</p>
            </div>
            {lawyers?.lawayer_linkedin !== null ? <div className='col'><p>{`Linkedin: ${lawyers?.lawayer_linkedin}`} </p></div> : <></>}
            {lawyers?.lawyer_phone !== null ? <div className='col'><p>{`Número telefónico: ${lawyers?.lawyer_phone}`} </p></div> : <></>}
          </div>
        </Panel>
      </div>

      <div className='mt-5'>
        <Panel header="Descripción">
          {lawyers.lawyer_description}
        </Panel>
      </div>
      <div className='mt-5'>
        <Panel header="Educación">
          <p>Cédula profesional: {lawyers?.lawyer_matricula}</p>
        </Panel>
      </div>
      <div className='mt-5'>
        <Panel header="Despacho">
          <p>Posición: </p>
          <p>Dirección: </p>
        </Panel>
      </div>
      <div className='mt-5 mb-5'>
        <Accordion>
          <AccordionTab header="Opiniones">
          </AccordionTab>
        </Accordion>
      </div>
    </div>
    <ConfirmaCita theState={theState}  confirmCalendar={confirmCalendar}></ConfirmaCita>
  </>)
}
